import { useDatabase } from '../composables/database'
import { Balances } from '../store/useInventory'

type BalanceModelReturn = {
  /**Return all balances on device */
  getAll: () => Promise<Balances>
  /**Writes balances to device */
  writeBalances: (data: Balances) => Promise<void>
  /**Deletes all balances from device */
  clearBalances: () => Promise<void>
}
export const BalanceModel = (): BalanceModelReturn => {
  const { run, query } = useDatabase()

  const getAll = async () => {
    const sql = `
        SELECT * FROM balances ORDER BY id DESC;
        `
    return await query(sql)
      .catch((error) => console.log(`Error grabbing all balances: ${error}`))
      .then((balances) => {
        if (balances && balances.length) {
          return JSON.parse(balances[0]['balances_data'])
        } else {
          return []
        }
      })
  }

  const writeBalances = async (data: Balances) => {
    const sql = `
        INSERT OR REPLACE INTO balances ('id', 'balances_data')
        VALUES ((SELECT id FROM balances WHERE id = 1), ?);
    `
    await run(sql, [JSON.stringify(data)]).catch((error) =>
      console.log(`Error writing balances to DB: ${error}`)
    )
  }

  const clearBalances = async () => {
    const sql = 'DELETE FROM balances;'
    await run(sql, []).catch((error) => {
      console.log(`Error deleting balances: ${error}`)
    })
  }

  return {
    getAll,
    writeBalances,
    clearBalances,
  }
}
